export interface Chapter {
  id: number;
  title: string;
  number: number;
  date: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: 'hanman' | 'riman' | 'guoman';
  tags: string[];
  rating: number;
  description: string;
  status: 'completed' | 'ongoing';
  chapters: Chapter[];
  views: number;
  updateDate: string;
  isHot: boolean;
  isNew: boolean;
}

export interface CategoryInfo {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: CategoryInfo[] = [
  { slug: 'hanman', name: '韩漫', description: '热门韩国漫画全集免费阅读', icon: 'ri-heart-pulse-line' },
  { slug: 'riman', name: '日漫', description: '经典日本漫画精选推荐', icon: 'ri-sun-line' },
  { slug: 'guoman', name: '国漫', description: '国产漫画精品连载合集', icon: 'ri-star-line' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '黑莲花攻略手册',
    author: '七喵',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20girl%20with%20dark%20hair%20in%20a%20historical%20fantasy%20setting%2C%20soft%20romantic%20atmosphere%2C%20elegant%20hanbok%20style%20clothing%2C%20cherry%20blossom%20petals%2C%20watercolor%20texture%2C%20warm%20toned%20background%2C%20manga%20cover%20art%20quality&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: 'hanman',
    tags: ['恋爱', '奇幻', '穿越'],
    rating: 9.7,
    description: '一朝穿越成为黑莲花女配，本想远离剧情安稳度日，却发现男主的目光越来越不对劲。她明明只想当个路人甲，却莫名成了所有人的焦点。当命运的车轮开始转动，她能否改写属于自己的结局？',
    status: 'ongoing',
    chapters: [
      { id: 101, title: '第120话 命运的转折', number: 120, date: '2026-08-03' },
      { id: 100, title: '第119话 暗流涌动', number: 119, date: '2026-07-27' },
      { id: 99, title: '第118话 秘密花园', number: 118, date: '2026-07-20' },
      { id: 98, title: '第117话 月光下的约定', number: 117, date: '2026-07-13' },
      { id: 97, title: '第116话 心动瞬间', number: 116, date: '2026-07-06' },
    ],
    views: 8920000,
    updateDate: '2026-08-03',
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: '剑尊归来',
    author: '李贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20martial%20arts%20master%20holding%20a%20glowing%20sword%2C%20dynamic%20action%20pose%2C%20dramatic%20lighting%20with%20energy%20effects%2C%20ancient%20eastern%20palace%20background%2C%20epic%20fantasy%20atmosphere%2C%20manga%20cover%20quality%2C%20warm%20gold%20and%20crimson%20tones&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: 'hanman',
    tags: ['武侠', '热血', '重生'],
    rating: 9.8,
    description: '天下第一剑尊惨遭背叛后陨落，百年后意外重生。带着前世的记忆与剑术，他誓要重回巅峰，手刃仇敌。然而这个时代早已物是人非，他能否在这全新的世界中再创传奇？',
    status: 'ongoing',
    chapters: [
      { id: 201, title: '第95话 剑意通天', number: 95, date: '2026-08-02' },
      { id: 200, title: '第94话 宿命对决', number: 94, date: '2026-07-26' },
      { id: 199, title: '第93话 破而后立', number: 93, date: '2026-07-19' },
      { id: 198, title: '第92话 绝境逢生', number: 92, date: '2026-07-12' },
      { id: 197, title: '第91话 风云再起', number: 91, date: '2026-07-05' },
    ],
    views: 7650000,
    updateDate: '2026-08-02',
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '社内相亲',
    author: '朴恩熙',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20style%2C%20handsome%20businessman%20in%20suit%20and%20pretty%20office%20lady%20having%20a%20romantic%20moment%20in%20modern%20office%2C%20pink%20cherry%20blossom%20petals%20falling%2C%20soft%20warm%20lighting%2C%20romantic%20comedy%20vibe%2C%20manga%20cover%20art&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: 'hanman',
    tags: ['恋爱', '职场', '喜剧'],
    rating: 9.5,
    description: '代替闺蜜去相亲，没想到对方竟然是公司的社长！本想糊弄过去就完事，社长却对她展开了疯狂的追求。这场"社内相亲"引发的浪漫喜剧，就此拉开帷幕！',
    status: 'completed',
    chapters: [
      { id: 301, title: '第88话 最终话 幸福', number: 88, date: '2026-06-15' },
      { id: 300, title: '第87话 求婚', number: 87, date: '2026-06-08' },
      { id: 299, title: '第86话 真心', number: 86, date: '2026-06-01' },
      { id: 298, title: '第85话 告白之夜', number: 85, date: '2026-05-25' },
      { id: 297, title: '第84话 心动的选择', number: 84, date: '2026-05-18' },
    ],
    views: 12300000,
    updateDate: '2026-06-15',
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20young%20swordsman%20with%20demon%20slayer%20uniform%20holding%20katana%2C%20water%20breathing%20effect%20with%20blue%20waves%2C%20dramatic%20action%20scene%2C%20traditional%20Japanese%20aesthetic%2C%20epic%20atmosphere%2C%20manga%20cover%20art%20quality&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: 'riman',
    tags: ['热血', '战斗', '奇幻'],
    rating: 9.9,
    description: '大正时代的日本，少年炭治郎一家惨遭鬼的杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹变回人类的方法，炭治郎踏上了成为鬼杀队剑士的道路。',
    status: 'completed',
    chapters: [
      { id: 401, title: '第205话 最终话', number: 205, date: '2026-01-10' },
      { id: 400, title: '第204话 决战', number: 204, date: '2026-01-03' },
      { id: 399, title: '第203话 黎明', number: 203, date: '2025-12-27' },
      { id: 398, title: '第202话 羁绊', number: 202, date: '2025-12-20' },
      { id: 397, title: '第201话 传承', number: 201, date: '2025-12-13' },
    ],
    views: 25000000,
    updateDate: '2026-01-10',
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    title: '咒术回战',
    author: '芥见下下',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20teenage%20sorcerer%20with%20spiky%20hair%20surrounded%20by%20cursed%20energy%20effects%2C%20dark%20supernatural%20atmosphere%2C%20urban%20Tokyo%20background%2C%20dynamic%20fighting%20pose%2C%20manga%20cover%20quality%2C%20purple%20and%20black%20energy%20auras&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: 'riman',
    tags: ['战斗', '奇幻', '校园'],
    rating: 9.8,
    description: '高中生虎杖悠仁在偶然的机会下吞下了诅咒之王两面宿傩的手指，从此踏入了咒术的世界。为了收集所有宿傩的手指并消灭诅咒，他加入了东京都立咒术高等专门学校。',
    status: 'ongoing',
    chapters: [
      { id: 501, title: '第248话 最终决战', number: 248, date: '2026-08-01' },
      { id: 500, title: '第247话 觉醒', number: 247, date: '2026-07-25' },
      { id: 499, title: '第246话 领域展开', number: 246, date: '2026-07-18' },
      { id: 498, title: '第245话 逆转', number: 245, date: '2026-07-11' },
      { id: 497, title: '第244话 宿命', number: 244, date: '2026-07-04' },
    ],
    views: 21000000,
    updateDate: '2026-08-01',
    isHot: true,
    isNew: true,
  },
  {
    id: 6,
    title: '葬送的芙莉莲',
    author: '山田钟人',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20elf%20mage%20girl%20with%20silver%20hair%20in%20a%20fantasy%20world%2C%20holding%20a%20magical%20staff%2C%20peaceful%20and%20melancholic%20atmosphere%2C%20beautiful%20landscape%20with%20flowers%2C%20soft%20warm%20lighting%2C%20slice%20of%20life%20fantasy%2C%20manga%20cover%20art&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: 'riman',
    tags: ['奇幻', '冒险', '治愈'],
    rating: 9.9,
    description: '打倒魔王的勇者一行人中的魔法使芙莉莲，是一个精灵。由于寿命远超其他伙伴，她经历了漫长的岁月。在伙伴们相继离世后，她踏上了"了解人类"的旅程。',
    status: 'ongoing',
    chapters: [
      { id: 601, title: '第132话 新的旅程', number: 132, date: '2026-07-31' },
      { id: 600, title: '第131话 回忆', number: 131, date: '2026-07-24' },
      { id: 599, title: '第130话 北方的尽头', number: 130, date: '2026-07-17' },
      { id: 598, title: '第129话 约定之地', number: 129, date: '2026-07-10' },
      { id: 597, title: '第128话 旅途的意义', number: 128, date: '2026-07-03' },
    ],
    views: 15600000,
    updateDate: '2026-07-31',
    isHot: true,
    isNew: false,
  },
  {
    id: 7,
    title: '一人之下',
    author: '米二',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20young%20man%20with%20supernatural%20abilities%2C%20traditional%20Chinese%20martial%20arts%20elements%2C%20modern%20urban%20setting%2C%20mysterious%20energy%20effects%2C%20dynamic%20composition%2C%20Chinese%20comic%20cover%20art%20quality&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: 'guoman',
    tags: ['异能', '热血', '冒险'],
    rating: 9.6,
    description: '普通大学生张楚岚因为爷爷的坟墓被盗，卷入了一场异人世界的纷争。为了查明爷爷死亡的真相，他开始接触这个隐藏在平凡世界之下的异能者江湖。',
    status: 'ongoing',
    chapters: [
      { id: 701, title: '第620话 真相', number: 620, date: '2026-08-02' },
      { id: 700, title: '第619话 对决', number: 619, date: '2026-07-26' },
      { id: 699, title: '第618话 唐门', number: 618, date: '2026-07-19' },
      { id: 698, title: '第617话 传承', number: 617, date: '2026-07-12' },
      { id: 697, title: '第616话 往事', number: 616, date: '2026-07-05' },
    ],
    views: 18900000,
    updateDate: '2026-08-02',
    isHot: true,
    isNew: false,
  },
  {
    id: 8,
    title: '斗破苍穹',
    author: '天蚕土豆',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20young%20warrior%20with%20flame%20powers%2C%20epic%20fantasy%20cultivation%20theme%2C%20ancient%20Chinese%20palace%20background%2C%20dramatic%20fire%20effects%2C%20martial%20arts%20cultivation%20atmosphere%2C%20Chinese%20comic%20cover%20art&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: 'guoman',
    tags: ['玄幻', '热血', '修炼'],
    rating: 9.5,
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后突然成了废人。在即将被家族放弃之际，一缕幽魂从他手上的戒指里浮现，从此开启了一段逆天改命的传奇之旅。',
    status: 'ongoing',
    chapters: [
      { id: 801, title: '第455话 决战云岚宗', number: 455, date: '2026-08-03' },
      { id: 800, title: '第454话 风起云涌', number: 454, date: '2026-07-27' },
      { id: 799, title: '第453话 三年之约', number: 453, date: '2026-07-20' },
      { id: 798, title: '第452话 中州风云', number: 452, date: '2026-07-13' },
      { id: 797, title: '第451话 强者之心', number: 451, date: '2026-07-06' },
    ],
    views: 32000000,
    updateDate: '2026-08-03',
    isHot: true,
    isNew: true,
  },
  {
    id: 9,
    title: '某天成为公主',
    author: 'Spoon',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20beautiful%20princess%20with%20long%20blonde%20hair%20in%20an%20elegant%20royal%20dress%2C%20fantasy%20palace%20background%2C%20romantic%20fairy%20tale%20atmosphere%2C%20sparkling%20magical%20effects%2C%20soft%20pastel%20warm%20tones%2C%20manga%20cover%20quality&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: 'hanman',
    tags: ['恋爱', '奇幻', '穿越'],
    rating: 9.6,
    description: '一觉醒来竟成了小说里的公主——还是个注定要被亲生父亲杀死的悲情公主！为了改变命运，她决定主动接近冷酷的父皇。但事情的发展似乎有些出乎意料……',
    status: 'ongoing',
    chapters: [
      { id: 901, title: '第110话 父皇的心', number: 110, date: '2026-08-01' },
      { id: 900, title: '第109话 舞会', number: 109, date: '2026-07-25' },
      { id: 899, title: '第108话 暗影', number: 108, date: '2026-07-18' },
      { id: 898, title: '第107话 真相逼近', number: 107, date: '2026-07-11' },
      { id: 897, title: '第106话 守护', number: 106, date: '2026-07-04' },
    ],
    views: 6700000,
    updateDate: '2026-08-01',
    isHot: false,
    isNew: true,
  },
  {
    id: 10,
    title: '全职猎人',
    author: '富坚义博',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20young%20boy%20with%20spiky%20black%20hair%20holding%20a%20fishing%20rod%2C%20adventure%20theme%2C%20fantasy%20world%20background%2C%20green%20nature%20elements%2C%20classic%20shonen%20manga%20style%2C%20manga%20cover%20art%20quality&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: 'riman',
    tags: ['冒险', '热血', '战斗'],
    rating: 9.9,
    description: '少年小杰为了寻找父亲金，决定参加猎人考试成为猎人。在旅途中他结识了奇犽、酷拉皮卡和雷欧力等伙伴，展开了一段充满未知与挑战的伟大冒险。',
    status: 'ongoing',
    chapters: [
      { id: 1001, title: '第401话 暗黑大陆', number: 401, date: '2026-07-15' },
      { id: 1000, title: '第400话 启程', number: 400, date: '2026-07-08' },
      { id: 999, title: '第399话 新世界', number: 399, date: '2026-07-01' },
      { id: 998, title: '第398话 继承战', number: 398, date: '2026-06-24' },
      { id: 997, title: '第397话 王子的条件', number: 397, date: '2026-06-17' },
    ],
    views: 28000000,
    updateDate: '2026-07-15',
    isHot: false,
    isNew: false,
  },
  {
    id: 11,
    title: '狐妖小红娘',
    author: '小新',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20beautiful%20fox%20spirit%20girl%20with%20red%20hair%20and%20fox%20ears%2C%20traditional%20Chinese%20elements%2C%20romantic%20fantasy%20atmosphere%2C%20ancient%20Chinese%20architecture%20background%2C%20soft%20warm%20peach%20blossom%20colors%2C%20Chinese%20comic%20cover&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: 'guoman',
    tags: ['恋爱', '奇幻', '古风'],
    rating: 9.4,
    description: '在人妖共存的世界里，狐妖涂山苏苏在一棵巨大的苦情树下为前世恋人牵线续缘。一段跨越千年的爱情故事，讲述了人与妖之间最纯粹的情感。',
    status: 'ongoing',
    chapters: [
      { id: 1101, title: '第520话 缘起缘灭', number: 520, date: '2026-08-01' },
      { id: 1100, title: '第519话 红线', number: 519, date: '2026-07-25' },
      { id: 1099, title: '第518话 前世今生', number: 518, date: '2026-07-18' },
      { id: 1098, title: '第517话 涂山', number: 517, date: '2026-07-11' },
      { id: 1097, title: '第516话 续缘', number: 516, date: '2026-07-04' },
    ],
    views: 14500000,
    updateDate: '2026-08-01',
    isHot: false,
    isNew: true,
  },
  {
    id: 12,
    title: '我独自升级',
    author: 'Chugong',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20dark%20haired%20hunter%20with%20glowing%20blue%20eyes%2C%20shadow%20army%20behind%20him%2C%20dungeon%20background%2C%20dark%20fantasy%20theme%2C%20dramatic%20lighting%2C%20powerful%20aura%2C%20webtoon%20cover%20quality&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: 'hanman',
    tags: ['战斗', '奇幻', '升级'],
    rating: 9.8,
    description: '被称为"人类最弱兵器"的E级猎人成振宇，在一次双 dungeon 任务中几乎丧命，却在绝境中获得了"系统"的力量。从此他开始了独自升级的旅程，一步一步成为最强的猎人。',
    status: 'completed',
    chapters: [
      { id: 1201, title: '第179话 最终话 新的开始', number: 179, date: '2026-05-20' },
      { id: 1200, title: '第178话 决战之日', number: 178, date: '2026-05-13' },
      { id: 1199, title: '第177话 君临', number: 177, date: '2026-05-06' },
      { id: 1198, title: '第176话 最终之战', number: 176, date: '2026-04-29' },
      { id: 1197, title: '第175话 觉醒', number: 175, date: '2026-04-22' },
    ],
    views: 35000000,
    updateDate: '2026-05-20',
    isHot: false,
    isNew: false,
  },
];

export const siteInfo = {
  name: '女神漫画',
  description: '女神漫画网官网及官方首页提供海量免费韩漫、日漫、国漫全集，涵盖热门漫画排行榜推荐，支持下拉式在线阅读，为漫画爱好者打造一站式阅读平台。',
  keywords: '女神漫画,女神漫画网官网,女神漫画官方首页,免费漫画,韩漫,日漫,国漫,全集,下拉式在线阅读,热门排行榜,漫画推荐',
  url: 'https://www.nvshenmanhua.com',
  logo: '女神漫画',
  email: 'contact@nvshenmanhua.com',
  phone: '400-888-6666',
  address: '广东省广州市天河区体育西路123号',
  icp: '粤ICP备2024000001号',
};

export const faqs = [
  {
    question: '女神漫画网是否真的免费？',
    answer: '是的，女神漫画网提供的所有漫画内容均完全免费。我们致力于为漫画爱好者打造一个免费的阅读平台，无需注册即可阅读海量漫画资源。',
  },
  {
    question: '如何搜索我喜欢的漫画？',
    answer: '您可以通过首页的搜索框输入漫画名称进行搜索，也可以按照韩漫、日漫、国漫等分类浏览，或者查看热门排行榜来发现好作品。',
  },
  {
    question: '支持什么设备阅读？',
    answer: '女神漫画网支持电脑、平板和手机等多种设备访问。网页采用响应式设计，在不同尺寸屏幕上都能获得舒适的阅读体验。',
  },
  {
    question: '漫画多久更新一次？',
    answer: '不同漫画的更新频率不同。热门连载漫画通常每周更新一话，部分作品可能采用双周更或月更的频率。您可以关注"最近更新"栏目获取最新内容。',
  },
  {
    question: '为什么有的漫画显示"连载中"？',
    answer: '"连载中"表示该漫画还在持续更新中，作者会定期发布新的章节。"已完结"则表示该漫画已经全部更新完成，您可以一口气阅读全部内容。',
  },
];